import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import {
	faTimes, faStepForward, faStepBackward, faAngleLeft, faAngleRight, faCheck, faArrowLeft, faInfo, faExclamation,
	faTachometerAlt, faPuzzlePiece, faTree, faSpinner, faLock, faPlus,
	faCheckCircle, faTimesCircle, faExternalLinkAlt, faQuestionCircle, faClock, faEdit, faPlay, faPen, faStop,
	faCircleNotch, faExclamationTriangle, faPencilAlt, faSave, faSignInAlt, faPause, faUserLock, faMinusCircle,
	faSitemap,
} from '@fortawesome/free-solid-svg-icons';

import {
	faCheckCircle as faCheckCircleReg,
} from '@fortawesome/free-regular-svg-icons';

import {
	faPaperPlaneTop,
} from '@fortawesome/pro-solid-svg-icons';

import {
	faListAlt, faChartBar, faPlusSquare, faMinusSquare, faBell, faTrashAlt, faKey, faDownload, faRobot, faBolt,
	faProjectDiagram, faBars, faLayerGroup, faSlidersH, faChartNetwork, faUsers, faCog, faInfoCircle, faGauge,
	faCalendarAlt, faFileCertificate, faCloudArrowUp, faFileDoc, faFileCsv, faFileCheck, faFileArchive, faMagnifyingGlassPlus,
	faMagnifyingGlassMinus, faSparkles, faFileSpreadsheet, faXmark, faSpinnerThird, faLink, faMessageQuestion, faDatabase,
	faMessagesQuestion, faGlobe,
} from '@fortawesome/pro-regular-svg-icons';

library.add(

	// SOLID
	faTimes, faStepForward, faStepBackward, faAngleLeft, faAngleRight, faCheck, faArrowLeft, faInfo, faExclamation,
	faTachometerAlt, faPuzzlePiece, faTree, faSpinner, faLock, faPlus,
	faCheckCircle, faTimesCircle, faExternalLinkAlt, faQuestionCircle, faClock, faEdit, faPlay, faPen, faStop,
	faCircleNotch, faExclamationTriangle, faPencilAlt, faSave, faSignInAlt, faPause, faUserLock, faMinusCircle,
	faSitemap, faPaperPlaneTop,

	// REGULAR
	faListAlt, faChartBar, faPlusSquare, faMinusSquare, faBell, faTrashAlt, faKey, faDownload, faRobot, faBolt,
	faProjectDiagram, faBars, faLayerGroup, faSlidersH, faChartNetwork, faUsers, faCog, faInfoCircle, faGauge,
	faCalendarAlt, faCheckCircleReg, faFileCertificate, faCloudArrowUp, faFileDoc, faFileCsv, faFileCheck, faFileArchive,
	faMagnifyingGlassPlus, faMagnifyingGlassMinus, faSparkles, faFileSpreadsheet, faXmark, faSpinnerThird, faLink,
	faMessageQuestion, faDatabase, faMessagesQuestion, faGlobe,
);

export default FontAwesomeIcon;
